import type { FormType } from "../../components/types";

export const getPairingFormValuesToHide = (forms: FormType[]): string[] => {
  let unavailableControls: string[] = [];
  forms.forEach(form => unavailableControls.push(form.control));
  return unavailableControls;
};
